import React from 'react';

import {DateRange} from 'components/ui-kit/DateRange';
import {periodChanged} from 'models/tracing/grid/table';

interface Props {
    range: [Date | null, Date | null];
}

export const Period = ({range}: Props) => (
    <DateRange
        value={range}
        onChange={(value) => {
            value ? periodChanged(value) : periodChanged([null, new Date()]);
        }}
    />
);
